import config from 'config';
import { Cookies } from 'core/utilities';
import { Logo, HeaderLogoSkeleton } from 'ui/components';
import { user } from 'core';
import { useRouterCurrent } from 'ui/containers/SectionBuilder/hooks';

const LogoBase = () => {
  const {
    data: { isMultiBrand },
    isLoading,
  } = user.hooks.useUser();
  const { isPublic } = useRouterCurrent();

  if (config.app.short === 'eud') {
    return <Logo brand={config.app.short} />;
  }

  if (Cookies.get('isMultiBrand') || isPublic) {
    return <Logo isMultiBrand={true} brand={config.app.short} />;
  }

  return (
    <>
      {isLoading ? (
        <HeaderLogoSkeleton />
      ) : (
        <Logo isMultiBrand={isMultiBrand} brand={config.app.short} />
      )}
    </>
  );
};

export default LogoBase;
